import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import {
  Container,
  MapContainer,
  SearchBtnContainer,
  ButtonContainer,
  ContentContainer,
  LoadingContainer,
  TableContainer,
  Table,
  TableHeaderWrap,
  TableHeaderRow,
  TableItem,
  TableGridContainer,
  TableHeader,
  SelectDevice,
  DownloadBtn,
} from "./LogPageStyle";
import WarningAlert from "./../../components/Alert/WarningAlert";
import LoadingAlert from "../../components/Alert/LoadingAlert";
import parseNMEA from "../../library/parseNMEA";
import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import InputForm from "../../components/Form/InputForm";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import { BASE_URL } from "../../constants";
import { useRecoilState, useRecoilValue } from "recoil";
import { accessTokenAtom } from "../../recoil/auth";
import { getDevices } from "../../apis/api/Device/getDevices";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import getDataDiff from "../../library/getDataDiff";
import {
  deviceCenterAtom,
  deviceCheckedArrAtom,
  deviceCntTimestampAtom,
  deviceColorArrAtom,
  deviceInfoArrAtom,
} from "../../recoil/device";
import LogMultiMap from "../../components/Map/LogMultiMap";
import { Button } from "@mui/material";
import { VariableSizeList } from "react-window";
import styled from "styled-components";
import { CSVLink } from "react-csv";
import { useTimeFormat } from "../../library/useTimeFormat";
import { timeFormatAtom } from "../../recoil/timeFormat";
import formatFullDateIfUTC from "../../library/formatFullDateIfUTC";
import { MdInfoOutline } from "react-icons/md"; // 아이콘 import

// 전체 기기의 최소/최대 Timestamp
let minTimestamp;
let maxTimestamp;

const AutoRenderList = styled(VariableSizeList)`
  & > div {
    display: flex !important;
    width: 100% !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05); /* 가볍고 세련된 구분선 */
  }
`;

const AutoRenderItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 15px; /* 여백 추가 */
  background-color: #f9f9f9;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05); /* 미세한 구분선 */
  transition: background-color 0.3s ease, transform 0.3s ease;
  &:hover {
    background-color: #e0f7fa; /* 호버 시 부드러운 컬러 변화 */
    transform: translateY(-3px); /* 살짝 떠오르는 느낌 */
  }
  & > div {
    flex: 1;
    text-align: center;
    font-size: 1rem;
    color: #333; /* 기본 텍스트 색상 */
  }
`;

const LogTableHeader = styled.div`
  display: flex;
  align-items: center;
  background-color: #f0f0f0; /* 헤더의 배경색을 약간 더 밝게 */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1); /* 헤더 구분선 */
  padding: 10px 15px; /* 여백 추가 */
  & > div {
    flex: 1;
    font-weight: 600; /* 고급스럽게 살짝 굵은 폰트 */
    font-size: 1.1rem; /* 살짝 큰 폰트 */
    text-align: center;
    color: #333; /* 기본 텍스트 색상 */
  }
`;

const TableTopOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  & select {
    height: 36px;
    border-radius: 8px; /* 부드러운 모서리 */
    border: 1px solid rgba(0, 0, 0, 0.15); /* 더 가벼운 테두리 */
    padding: 0 12px;
    font-size: 1rem;
    background-color: #fff;
    color: #333;
    transition: border-color 0.3s ease;
    &:hover, &:focus {
      border-color: #0275d8; /* 포커스 시 테두리 강조 */
    }
  }
`;

export const SelectDeviceOption = styled.select`
  height: 36px;
  width: 180px;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1); /* 기본적인 테두리 */
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 1rem;
  color: #333;
  transition: all 0.3s ease;
  &:hover {
    border-color: #0275d8; /* 호버 시 테두리 강조 */
    box-shadow: 0 4px 12px rgba(2, 117, 216, 0.1);
  }
  &:focus {
    outline: none;
    border-color: #0275d8;
  }
`;

const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b8b8b;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: left;
  margin-bottom: 15px;
  background-color: #f9f9f9;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 10px 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  gap: 10px; /* 아이콘과 텍스트 간격 */
`;


    // 컴포넌트 선언
    const MultiLogPage = () => {
      const accessToken = useRecoilValue(accessTokenAtom);
      const [serialInfoList, setSerialInfoList] = useRecoilState(deviceInfoArrAtom);
      const [deviceCheckedList, setDeviceCheckedList] = useRecoilState(deviceCheckedArrAtom);
      const [deviceCenter, setDeviceCenter] = useRecoilState(deviceCenterAtom);
      const deviceColor = useRecoilValue(deviceColorArrAtom);
      const cntTimestamp = useRecoilValue(deviceCntTimestampAtom);
      const [deviceMap, setDeviceMap] = useState(new Map());
      const [serialNumList, setSerialNumList] = useState([]);
      const [logButtonCountDumState, setLogButtonCountDumState] = useState(0);
      const [selectedDevice, setSelectedDevice] = useState([]);
      const [startDate, setStartDate] = useState(null);
      const [endDate, setEndDate] = useState(null);
      const [isQuery, setIsQuery] = useState(false);
      const [isChecked, setIsChecked] = useState(true);
      const [logDeviceSerial, setLogDeviceSerial] = useState("");
      const [logCSVdataClick, setLogCSVdataClick] = useState(0);
      const [deviceInputType, setDeviceInputType] = useState("select"); // 검색 방식 선택 상태
      const [manualDeviceInput, setManualDeviceInput] = useState(""); // 직접 입력한 기기명 상태
      const csvLink = useRef();
      const timeFormat = useRecoilValue(timeFormatAtom);
      const { date } = useTimeFormat();
      const { t } = useTranslation();

      // 시리얼 가져오기
      useEffect(() => {
        getDevices(accessToken)
          .then((res) => {
            setSerialNumList(res);
            const deviceNameList = [];
            res.map((item) => {
              deviceNameList.push({ serial: item.serial, name: item.name });
              return 0;
            });
            setSerialInfoList(deviceNameList);
          })
          .catch((error) => {
            console.error("Error fetching devices: ", error);
          });
      }, []);

      // 로그 조회하기
      const queryOnClick = async () => {
          if (!startDate) {
        WarningAlert(t(`Please select a start date.`));
        return;
      }

      if (!endDate) {
        WarningAlert(t(`Please select an end date.`));
        return;
      }

      if (
        (deviceInputType === "select" && (!selectedDevice || selectedDevice.length === 0)) ||
        (deviceInputType === "input" && !manualDeviceInput)
      ) {
        WarningAlert(t(`Please select or enter a device.`));
        return;
      } else {
      if (selectedDevice.length > 10) {
        setIsQuery(false);
        WarningAlert(t(`You can only select up to 10 devices`));
        return;
      }
      if (getDataDiff(startDate, endDate) > 0) {
        setIsQuery(false);
        WarningAlert(t(`log viewing is only possible for up to 24 hours`));
        return;
      } else {
        LoadingAlert();

        // 사용자가 select 또는 input 방식을 선택했는지에 따라 serial 값을 다르게 처리
        let serialQuery;
        if (deviceInputType === "input") {
          // input 방식일 때: 사용자가 입력한 값을 serial로 사용
          serialQuery = manualDeviceInput;
        } else {
          // select 방식일 때: 기존 selectedDevice 사용
          serialQuery = selectedDevice;
        }

        // API 요청 주소를 querylogRawTemp로 변경 (input 방식일 때)
        const apiEndpoint =
          deviceInputType === "input"
            ? `${BASE_URL}/devicelog/log/querylogRawTemp`
            : `${BASE_URL}/devicelog/log/querylogRaw`;

        // API 호출
        const { data } = await axios.get(apiEndpoint, {
          params: {
            start:
              timeFormat === "utc" ? formatFullDateIfUTC(startDate) : startDate,
            end: timeFormat === "utc" ? formatFullDateIfUTC(endDate) : endDate,
            serial: serialQuery,
          },
        });

        let checkedList = {};
        minTimestamp = 0;
        maxTimestamp = 0;

        const totalLength = Object.values(data).reduce(
          (acc, arr) => acc + arr.length,
          0
        );
        if (totalLength > 0) {
          for (const key in data) {
            if (data.hasOwnProperty(key)) {
              const currentArray = data[key];
              if (currentArray.length > 0) {
                checkedList[key] = true;
                setDeviceMap((prev) => {
                  const newDeviceMap = new Map(prev);
                  newDeviceMap.set(key, {
                    searchLog: [],
                    selectedLog: [],
                    selectedPath: [],
                    csvLog: [],
                    prevTimestamp: 0,
                    startDate: 0,
                    endDate: 0,
                  });
                  return newDeviceMap;
                });
                for (let i = 0; i < currentArray.length; i++) {
                  const parsedNMEA = parseNMEA(currentArray[i]);
                  const currentTimestamp = new Date(
                    date(parsedNMEA.date)
                  ).getTime();

                  if (minTimestamp === 0 || currentTimestamp < minTimestamp) {
                    minTimestamp = currentTimestamp;
                  }
                  if (currentTimestamp > maxTimestamp) {
                    maxTimestamp = currentTimestamp;
                  }
                  setDeviceMap((prev) => {
                    const newDeviceMap = new Map(prev);
                    newDeviceMap.get(key).searchLog[
                      new Date(date(parsedNMEA.date)).getTime()
                    ] = {
                      date: date(parsedNMEA.date),
                      lat: parsedNMEA.lat,
                      lng: parsedNMEA.lon,
                      height: parsedNMEA.height,
                      quality: parsedNMEA.quality,
                    };
                    newDeviceMap.get(key).selectedLog[i] = {
                      date: date(parsedNMEA.date),
                      lat: parsedNMEA.lat,
                      lng: parsedNMEA.lon,
                      height: parsedNMEA.height,
                      quality: parsedNMEA.quality,
                    };
                    newDeviceMap.get(key).selectedPath[i] = {
                      lat: parsedNMEA.lat,
                      lng: parsedNMEA.lon,
                    };
                    newDeviceMap.get(key).csvLog[i] = {
                      [`time(${timeFormat})`]: date(parsedNMEA.date),
                      lat: parsedNMEA?.lat?.toFixed(9),
                      lon: parsedNMEA?.lon?.toFixed(9),
                      alt: parsedNMEA?.height,
                      quality: currentArray[i]?.quality,
                      speed: 0,
                      azimuth: 0,
                      dop: currentArray[i]?.hdop,
                      sat: currentArray[i]?.satelliteCnt,
                      temp: currentArray[i]?.utcTime,
                    };
                    if (i === 0) {
                      newDeviceMap.get(key).startDate = date(parsedNMEA.date);
                    }
                    if (i === currentArray.length - 1) {
                      newDeviceMap.get(key).endDate = date(parsedNMEA.date);
                    }
                    console.log(newDeviceMap);
                    return newDeviceMap;
                  });
                }
              }
            }
          }
        } else {
          WarningAlert(t(`There is no data matching the conditions`));
          return;
        }
        setDeviceCheckedList(checkedList);
        setIsQuery(true);
        Swal.close();
      }
      setLogButtonCountDumState((prev) => prev + 1);
    }
  };


  // 체크 박스 토글
  const toggleCheck = (serial) => {
    setDeviceCheckedList((prev) => {
      const newCheckedList = { ...prev };
      newCheckedList[serial] = !newCheckedList[serial];
      return newCheckedList;
    });
  };

  // 전체 체크 박스 토글
  const toggleAllCheck = () => {
    setIsChecked((prev) => !prev);
    setDeviceCheckedList((prev) => {
      const newCheckedList = {};
      const allChecked = Object.values(prev).every((isChecked) => isChecked);
      Object.keys(prev).forEach((serial) => {
        newCheckedList[serial] = !allChecked;
      });
      return newCheckedList;
    });
  };

  // 기기 센터 토글
  const deviceCenterToggle = (serial) => {
    setDeviceCenter((prev) => {
      return prev === serial ? null : serial;
    });
  };

  const calculateItemHeight = (index) => {
    return 40;
  };

  useEffect(() => {
    if (csvLink.current) csvLink.current.link.click();
  }, [logCSVdataClick]);

  return (
    <Container style={{ maxWidth: "1300px" }}>
      <Seo title={t(`log`)} />
      <PageHeader title={t(`log`)} />
      <MapContainer>
        {isQuery ? (
          <LogMultiMap
            deviceMap={deviceMap}
            startTimestamp={minTimestamp}
            endTimestamp={maxTimestamp}
          />
        ) : (
          <LoadingContainer>{t(`please search the log`)}</LoadingContainer>
        )}
      </MapContainer>
      <InfoMessage>
        <MdInfoOutline style={{ color: "#0275d8", fontSize: "1.2rem" }} />
        {t(`logs can only be viewed for up to 24 hours`)}
      </InfoMessage>
      <ContentContainer>
        <InputForm
          startDate={setStartDate}
          endDate={setEndDate}
          selectedDevice={setSelectedDevice}
          isMulti={true}
          deviceInputType={deviceInputType}
          setDeviceInputType={setDeviceInputType}
          manualDeviceInput={manualDeviceInput}
          setManualDeviceInput={setManualDeviceInput}
        />
        <ButtonContainer
          onClick={() => queryOnClick()}
          style={{
            borderBottom: "none",
            cursor: startDate && endDate && selectedDevice ? "pointer" : "auto",
            opacity: startDate && endDate && selectedDevice ? 1 : 0.5,
          }}
        >
          <SearchBtnContainer>{t(`search`)}</SearchBtnContainer>
        </ButtonContainer>
      </ContentContainer>
      {isQuery && (
        <>
          <TableTopOption>
            <div>
              {logDeviceSerial !== "" && (
                <Button
                  variant="contained"
                  style={{
                    marginRight: "5px",
                    backgroundColor: "#1565c0",
                  }}
                  onClick={() => setLogDeviceSerial("")}
                >
                  Back
                </Button>
              )}
              {/* 로그 조회 및 다운로드 기기 선택 */}
              <SelectDevice
                value={logDeviceSerial}
                onChange={(e) => setLogDeviceSerial(e.target.value)}
              >
                <option value="">Choose a Device</option>
                {Array.from(deviceMap.entries())
                  .sort(([, pathA], [, pathB]) => {
                    // Start Date 순서로 Sorting
                    const dateA = pathA.selectedPath[0]?.date;
                    const dateB = pathB.selectedPath[0]?.date;
                    if (dateA && dateB) {
                      return new Date(dateA) - new Date(dateB);
                    } else {
                      return 0;
                    }
                  })
                  .map(([serial]) => {
                    return <option value={serial}>{serial}</option>;
                  })}
            </SelectDevice>
            </div>
            {logDeviceSerial !== "" &&
              deviceMap.get(logDeviceSerial)?.csvLog && (
                <div>
                  <DownloadBtn
                    variant="outlined"
                    onClick={() => setLogCSVdataClick((prev) => prev + 1)}
                  >
                    Download
                  </DownloadBtn>
                  <CSVLink
                    ref={csvLink}
                    style={{
                      display: "none",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                    }}
                    data={deviceMap.get(logDeviceSerial)?.csvLog}
                    filename={`${
                      deviceMap.get(logDeviceSerial)?.csvLog[0]?.[
                        `time(${timeFormat})`
                      ]
                    }_${logDeviceSerial}.csv`}
                  />
                </div>
              )}
          </TableTopOption>
          <TableContainer>
            <Table>
              <TableHeaderWrap>
                {logDeviceSerial === "" ? (
                  <TableHeaderRow>
                    <TableHeader>
                      <input
                        type="checkbox"
                        onChange={() => toggleAllCheck()}
                        checked={isChecked}
                        style={{
                          width: "17.5px",
                          height: "17.5px",
                          position: "relative",
                          top: "3px",
                        }}
                      />
                    </TableHeader>
                    <TableHeader>{t("No. ")}</TableHeader>
                    <TableHeader>{t("Color")}</TableHeader>
                    <TableHeader>{t("serial number")}</TableHeader>
                    <TableHeader>{t("latitude")}</TableHeader>
                    <TableHeader>{t("longitude")}</TableHeader>
                    <TableHeader>{t("height")}</TableHeader>
                    <TableHeader>{t("quality")}</TableHeader>
                    <TableHeader>{t("Start")}</TableHeader>
                    <TableHeader>{t("End")}</TableHeader>
                    <TableHeader>Length</TableHeader>
                  </TableHeaderRow>
                ) : (
                  <LogTableHeader>
                    <div>{t("date")}</div>
                    <div>{t("latitude")}</div>
                    <div>{t("longitude")}</div>
                    <div>{t("height")}</div>
                    <div>{t("quality")}</div>
                  </LogTableHeader>
                )}
              </TableHeaderWrap>
              {/* 로그 모니터링 조회 */}
              <tbody style={{ background: "#fff", userSelect: "none" }}>
                {logDeviceSerial === "" &&
                  Array.from(deviceMap.entries())
                    .sort(([, pathA], [, pathB]) => {
                      // Start Date 순서로 Sorting
                      const dateA = pathA.selectedPath[0]?.date;
                      const dateB = pathB.selectedPath[0]?.date;
                      if (dateA && dateB) {
                        return new Date(dateA) - new Date(dateB);
                      } else {
                        return 0;
                      }
                    })
                    .map(([serial, path], index) => {
                      return (
                        path?.selectedPath[0] && (
                          <TableGridContainer
                            key={serial}
                            onClick={() => deviceCenterToggle(serial)}
                            style={{
                              background:
                                serial === deviceCenter ? "#bddbff" : "",
                            }}
                          >
                            <td style={{ display: "none" }}>
                              {path.searchLog[cntTimestamp]
                                ? (path.prevTimestamp = cntTimestamp)
                                : false}
                            </td>
                            <TableItem>
                              <input
                                type="checkbox"
                                checked={deviceCheckedList[serial]}
                                onChange={() => toggleCheck(serial)}
                                style={{
                                  width: "17.5px",
                                  height: "17.5px",
                                  position: "relative",
                                  top: "3px",
                                }}
                              />
                            </TableItem>
                            <TableItem>{index + 1} </TableItem>
                            <TableItem>
                              <div
                                style={{
                                  display: "inline-block",
                                  background: deviceColor[serial] || "#000",
                                  border: 0,
                                  borderRadius: "50%",
                                  width: "17.5px",
                                  height: "17.5px",
                                  position: "relative",
                                  left: "3px",
                                  top: "3px",
                                }}
                              ></div>
                            </TableItem>
                            <TableItem>{serial}</TableItem>
                            <TableItem>
                              {path.searchLog[cntTimestamp]?.lat
                                ? path.searchLog[cntTimestamp]?.lat.toFixed(9)
                                : path.searchLog[path.prevTimestamp]?.lat
                                ? path.searchLog[
                                    path.prevTimestamp
                                  ]?.lat.toFixed(9)
                                : " - "}
                            </TableItem>
                            <TableItem>
                              {path.searchLog[cntTimestamp]?.lng
                                ? path.searchLog[cntTimestamp]?.lng.toFixed(9)
                                : path.searchLog[path.prevTimestamp]?.lng
                                ? path.searchLog[
                                    path.prevTimestamp
                                  ]?.lng.toFixed(9)
                                : " - "}
                            </TableItem>
                            <TableItem>
                              {path.searchLog[cntTimestamp]?.height
                                ? path.searchLog[cntTimestamp]?.height.toFixed(
                                    3
                                  )
                                : path.searchLog[path.prevTimestamp]?.height
                                ? path.searchLog[
                                    path.prevTimestamp
                                  ]?.height.toFixed(3)
                                : " - "}
                              {path.searchLog[cntTimestamp]?.height ||
                              path.searchLog[path.prevTimestamp]?.height
                                ? "m"
                                : ""}
                            </TableItem>
                            <TableItem>
                              {path.searchLog[
                                cntTimestamp
                              ]?.quality.toUpperCase()
                                ? path.searchLog[
                                    cntTimestamp
                                  ]?.quality.toUpperCase()
                                : path.searchLog[
                                    path.prevTimestamp
                                  ]?.quality.toUpperCase()
                                ? path.searchLog[
                                    path.prevTimestamp
                                  ]?.quality.toUpperCase()
                                : " - "}
                            </TableItem>
                            <TableItem>{path?.startDate || " - "}</TableItem>
                            <TableItem>{path?.endDate || " - "}</TableItem>
                            <TableItem>{path.selectedPath?.length}</TableItem>
                          </TableGridContainer>
                        )
                      );
                    })}
                {logDeviceSerial !== "" &&
                  deviceMap.get(logDeviceSerial)?.selectedLog && (
                    <AutoRenderList
                      height={400}
                      itemCount={
                        deviceMap.get(logDeviceSerial).selectedLog.length
                      }
                      itemSize={(index) => calculateItemHeight(index)}
                      width={"100%"}
                    >
                      {({ index, style }) => (
                        <AutoRenderItem style={style}>
                          <div>
                            {
                              deviceMap.get(logDeviceSerial).selectedLog[index]
                                ?.date
                            }
                          </div>
                          <div>
                            {deviceMap
                              .get(logDeviceSerial)
                              .selectedLog[index]?.lat?.toFixed(9)}
                          </div>
                          <div>
                            {deviceMap
                              .get(logDeviceSerial)
                              .selectedLog[index]?.lng?.toFixed(9)}
                          </div>
                          <div>
                            {deviceMap
                              .get(logDeviceSerial)
                              .selectedLog[index]?.height?.toFixed(3)}
                            m
                          </div>
                          <div>
                            {
                              deviceMap.get(logDeviceSerial).selectedLog[index]
                                ?.quality
                            }
                          </div>
                        </AutoRenderItem>
                      )}
                    </AutoRenderList>
                  )}
              </tbody>
            </Table>
          </TableContainer>
        </>
      )}
      <Footer />
    </Container>
  );
};


export default requiredAuth(MultiLogPage);
